import { QUARTER_DATE_RANGE_MAP } from '../constants';

import { parseStatementIdAsYearAndQuarter } from '..';

/**
 * @param statementId - a statement ID like '1617120673AI0311628420201U'
 * @returns - a {@link DateRange} representing the statement period in UTC, or null if the date
 * range could not be found.
 */
export const getDateRangeFromStatementId = (
    statementId: Maybe<string>,
): Maybe<DateRange> => {
    if (statementId === null) {
        return null;
    }

    const yearAndQuarter = parseStatementIdAsYearAndQuarter(statementId);

    if (yearAndQuarter === null) {
        return null;
    }

    const { year, quarter } = yearAndQuarter;

    const quarterDateRange = QUARTER_DATE_RANGE_MAP?.[quarter] ?? null;

    if (quarterDateRange === null) {
        return null;
    }

    const end = new Date(
        Date.UTC(
            year,
            quarterDateRange.end.month,
            quarterDateRange.end.day,
            23,
            59,
            59,
            999,
        ),
    );

    const start = new Date(
        Date.UTC(
            year,
            quarterDateRange.start.month,
            quarterDateRange.start.day,
            0,
            0,
            0,
            0,
        ),
    );

    return {
        end,
        start,
    };
};
